import React from 'react';
import FlowStatusLayout from '~/client/components/flow-status-layout/flow-status-layout';
import type { RenewStatus as Props } from './renew-status.types';

const RenewStatus: React.FC<Props> = props => <FlowStatusLayout {...props} />;

export default RenewStatus;
